import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { map } from 'rxjs/operators';

export const DeclarationEndGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const dossierSB = inject(DossierSandboxService);
  const router = inject(Router);

  const redirectUrl = '/login';

  return dossierSB.dossier$.pipe(
    map((dossier) => {
      return (dossier?.appointment?.id != null &&
        (dossierSB.statesComplete.findIndex(
          (state) => dossier.state === state
        ) !== -1 ||
          dossier?.appointment.status === 'CANCELLED')) ||
        !!dossier?.requestAppointment?.status ||
        dossier?.state === 'ABANDONED'
        ? true
        : router.parseUrl(redirectUrl);
    })
  );
};
